/* eslint "react/prefer-stateless-function": [2, { "ignorePureComponents": true }] */
import * as React from "react";

export class HealthCheckComponent extends React.PureComponent {
  render() {
    return <div data-testid="ok">OK</div>;
  }
}
